import { formatCurrency, formatDate } from "@/common/utils/formatters";
import { BadgeHelp, Dot } from "lucide-react";
import { Tooltip } from "react-tooltip";
import { TotalAvailableMappedData } from "@/common/types/totalAvailable.type";

interface PaymentAdvancesIndicatorProps {
    totalAvailableData: TotalAvailableMappedData | undefined;
}

export const PaymentAdvancesIndicator = ({ totalAvailableData }: PaymentAdvancesIndicatorProps) => {
    return (
        <>
            <div className="flex gap-8">
                <div className="flex flex-col">
                    <p className="text-white-800 text-sm font-light italic">Dias para pagamento</p>
                    <div className="flex items-center">
                        <p className="text-white-800 font-bold text-lg">
                            {totalAvailableData?.days_remaining_to_be_paid} dias
                        </p>
                        <Dot className="w-4 h-4 text-white-400" />
                        <p className="text-white-400 text-xs font-light italic">
                            {totalAvailableData?.date_to_be_paid ? formatDate(new Date(totalAvailableData.date_to_be_paid)) : '-'}
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <div className='flex flex-col'>
                        <p className="text-yellow-400 text-sm font-light italic">Valor a receber</p>
                        <p className="text-yellow-400 font-bold text-lg">
                            {formatCurrency(totalAvailableData?.max_interested_available_to_be_advanced || 0)}
                        </p>
                    </div>
                    <BadgeHelp className='w-6 h-6 text-warning' data-tooltip-id="advance-limit-tooltip" />
                    <Tooltip id="advance-limit-tooltip">
                        Valores abaixo de R$100,00 não podem ser antecipados
                    </Tooltip>
                </div>
            </div>
        </>
    );
};